/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkstepconnect3Inputs */

const en_profilelinkstepconnect3 = /** @type {(inputs: Profilelinkstepconnect3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap "Connect to an organizer account".`)
};

const de_profilelinkstepconnect3 = /** @type {(inputs: Profilelinkstepconnect3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippe auf „Mit Veranstalter-Konto verbinden“.`)
};

/**
* | output |
* | --- |
* | "Tap \"Connect to an organizer account\"." |
*
* @param {Profilelinkstepconnect3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkstepconnect3 = /** @type {((inputs?: Profilelinkstepconnect3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkstepconnect3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkstepconnect3(inputs)
	return de_profilelinkstepconnect3(inputs)
});
export { profilelinkstepconnect3 as "profileLinkStepConnect" }